<template>

  <!-- Modal -->
<div class="modal fade" id="chartFullscreenwaterlevelModal" tabindex="-1" aria-labelledby="chartFullscreenwaterlevelModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="chartFullscreenwaterlevelModalLabel">
กราฟ</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body px-4 py-5">
             <div class="chart-header">
                        <div class="chart-title">
                            <i class="bi bi-bar-chart-fill text-cyan"></i>
                            <h3>กราฟข้อมูลระดับน้ำ</h3>
                        </div>
                        <div class="time-selector" style="font-size: 10px;">
                            <button v-for="(period, idx) in timePeriods" :key="period" :class="['time-btn', { active: selectedPeriod === idx }]" @click="selectedPeriod = idx,loadChartData('IL||IRAI||ISAL', idx)">
                                {{ period }}
                            </button>
                        </div>
                    </div>
                    <apexchart  type="area" height="350" style="width: 100%;" :options="chartOptions" :series="series"></apexchart>
                   
      </div>
   
    </div>
  </div>
</div>

     <!-- Pump Confirm Modal -->
<div class="modal fade" id="pumpConfirmModal" tabindex="-1" aria-labelledby="pumpConfirmModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content pump-confirm-modal-content">
      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title" id="pumpConfirmModalLabel">
          <i class="bi bi-shield-lock-fill text-cyan me-2"></i>
          ยืนยันรหัสผ่านก่อน{{ pumpStatus ? 'ปิด' : 'เปิด' }}ปั๊มน้ำ
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetPumpConfirm()"></button>
      </div>
      <div class="modal-body pt-2">
        <p class="pump-confirm-desc">
          เพื่อความปลอดภัย กรุณากรอกรหัสผ่านบัญชีของคุณเพื่อยืนยันการ{{ pumpStatus ? 'ปิด' : 'เปิด' }}การทำงานของปั๊มน้ำที่สถานีนี้
        </p>
        <div class="pump-confirm-input-group" :class="{ 'is-invalid': pumpConfirmError }">
          <i class="bi bi-lock-fill"></i>
          <input
            :type="showPumpPassword ? 'text' : 'password'"
            class="pump-confirm-input"
            v-model="pumpConfirmPassword"
            placeholder="รหัสผ่าน"
            autocomplete="current-password"
            @keyup.enter="confirmPumpAction()"
          />
          <i
            class="bi toggle-eye"
            :class="showPumpPassword ? 'bi-eye-slash' : 'bi-eye'"
            @click="showPumpPassword = !showPumpPassword"
          ></i>
        </div>
        <div class="pump-confirm-error" v-if="pumpConfirmError">
          <i class="bi bi-exclamation-circle-fill"></i> {{ pumpConfirmError }}
        </div>
      </div>
      <div class="modal-footer border-0 pt-0">
        <button type="button" class="btn pump-cancel-btn" data-bs-dismiss="modal" @click="resetPumpConfirm()">ยกเลิก</button>
        <button
          type="button"
          class="btn pump-confirm-btn"
          :class="{ 'pump-toggle-on': pumpStatus }"
          :disabled="pumpConfirmLoading || !pumpConfirmPassword"
          @click="confirmPumpAction()"
        >
          <i v-if="pumpConfirmLoading" class="bi bi-arrow-repeat spin"></i>
          <span v-else>ยืนยัน{{ pumpStatus ? 'ปิด' : 'เปิด' }}ปั๊ม</span>
        </button>
      </div>
    </div>
  </div>
</div>

<nav class="navbar navbar-expand-lg navbar-light bg-light py-1 fixed-top" style=" padding: 0 1.5rem;">
  <div class="container-fluid">
  <div class="mt-2 me-3">
     <span class="">
          <img src="../assets/envionyx-logo.png" alt="" style="height: 30px;">
                 <img class="ms-1" src="../assets/envionyx-banner.png" alt="" style="height: 18px;">
        <span class="breadcrumb ms-1">Node List → <span class="breadcrumb-active">Node Detail</span></span>
             </span>
  </div>
   
                       
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
      <router-link  style="width: 100%;"    to='/' >
                 <button type="button" class="btn btn-outline-dark border-0 px-2 py-1 rounded-5" style="font-family: 'Kanit-Regular';font-size: 14px;"> 
                        <i class="bi bi-arrow-left"></i> กลับไปยังหน้าหลัก
                        
                        </button>
                               </router-link>
        <!-- <li class="nav-item ms-2">
        <router-link  v-if="role!='user'|| role!='User'"
                            to='/management/group/list' 
                            class="">
 <button type="button" class="btn btn-outline-dark px-2 py-1" >จัดการเพลตฟอร์ม</button>
                        </router-link>
        </li> -->
      </ul>
          <form class="d-flex" style="">
           <div class="col-12" style="">
               <div class="row py-2 px-0 rounded-5" style="background-color: #75BCEF1C;">
                 <div class="col-xl-3 col-lg-3 col-md-3 col-sm-2 col-2">
                 <div style="height: 40px;width: 40px;background-color: #75BCEF;font-size: 16px;" class="rounded-circle text-center pt-2 ms-1  text-white">
                    WT
                 </div>
                </div>
                <div class="col-xl-6 col-xl-6 col-md-6 col-sm-8 col-8">
                    <div style="font-size: 11px;">
                   {{ email }}
                    </div>
                   <div style="font-size: 12px;font-family: 'Kanit-Regular';">
                     {{ role }}
                   </div>
                </div>
               <div class="col-1 dropdown text-end">
                <div class="" type="button" id="navbarDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-three-dots-vertical" style="font-size: 25px;"></i>
                </div>
                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                    <router-link to="/info" style="text-decoration: none;">
                    <li type="button"><a class="dropdown-item" ><i class="bi bi-person"></i> บัญชีผู้ใช้</a></li>
                    </router-link>
                     <li type="button" @click="logout()"><a class="dropdown-item" ><i class="bi bi-box-arrow-right"></i> ออกจากระบบ</a></li>
    
                </ul>
                </div>
               </div>
            </div>
        <!-- <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
        <button class="btn btn-outline-success" type="submit">Search</button> -->
      </form>
    </div>
  </div>
</nav>
<div class="bg-gradient">
   <div style="height: 12vh;"></div>
<div class="col-12">
    <div class="row justify-content-center">
         <div class="main-container px-4" style="max-width: 1460px;">
        <div class="content-grid">
            <div class="left-column " > 
                <div class="card location-card">
                    <div class="">
                   <div class="row ">
                         <div class=" col-xl-8 col-lg-8 col-md-8  col-sm-12 col-12">
                            <div class="location-header">
                                <i class="bi bi-geo-alt-fill text-cyan"></i>
                                <h3>{{ locationData.name }}</h3>
                            </div>
                            <p class="info-item">
                                <i class="bi bi-pin-map"></i>
                                {{ locationData.location }}
                            </p>
                            <p class="info-item">
                                <i class="bi bi-globe"></i>
                                {{ locationData.Latitude }}, {{ locationData.Longitude }}
                            </p>
                            <p class="info-item">
                                <i class="bi bi-mailbox"></i>
                                ไปรษณีย์: {{ locationData.postcode }}
                            </p>
                            <p class="info-item">
                                <i class="bi bi-calendar3"></i>
                                สร้างเมื่อ: {{ locationData.createdAt }}
                            </p>
                        </div>
                                <div class="col-xl-4  col-lg-4 col-md-4 col-sm-12 col-12 text-center rounded-4">
                <div class="rounded-4 " style="height: 150px;" >
              <l-map v-if="loading==true" lass="rounded-4 col-12"
    :zoom="14"
    :center="[locationData.Latitude, locationData.Longitude]"
    style="height: 150px; "
  >
    <l-tile-layer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
    />

 
    <l-marker :lat-lng="[locationData.Latitude, locationData.Longitude]">
      <l-icon class-name="someExtraClass">
      
              <div class="marker-container" v-if="realtimeData.IA==1">
                        <div class="marker-dot">
                            <i class="bi bi-water" style="color: white;font-size: 18px;"></i>
                        </div>
                        <div class="marker-label">
                            {{ locationData.name }}
                        </div>
                    </div>

                        <div class="marker-container" v-if="realtimeData.IA==3">
                        <div class="marker-dot-warning">
                            <i class="bi bi-water" style="color: white;font-size: 18px;"></i>
                        </div>
                        <div class="marker-label-warning">
                            {{ locationData.name }}
                        </div>
                    </div>

                     <div class="marker-container" v-if="realtimeData.IA==2">
                        <div class="marker-dot-danger">
                            <i class="bi bi-water" style="color: white;font-size: 18px;"></i>
                        </div>
                        <div class="marker-label-danger">
                            {{ locationData.name }}
                        </div>
                    </div>
      </l-icon>
    </l-marker>
  </l-map>
                </div>
              </div>
                   </div>
                
                    </div>
                </div>

            
                                <!-- Pump Control Card -->
                <div class="card pump-card">
                    <div class="pump-card-header">
                        <div class="pump-title">
                            <i class="bi bi-fan pump-icon-spin" :class="{ 'is-spinning': pumpStatus }"></i>
                            <h3>ควบคุมปั๊มน้ำ</h3>
                        </div>
                        <span class="pump-status-badge" :class="pumpStatus ? 'pump-on' : 'pump-off'">
                            <span class="pump-status-dot"></span>
                            {{ pumpStatus ? 'กำลังทำงาน' : 'ปิดอยู่' }}
                        </span>
                    </div>

                    <div class="pump-mode-switch">
                        <button type="button" class="pump-mode-btn" :class="{ active: pumpControlMode === 'manual' }" @click="pumpControlMode = 'manual'">
                            <i class="bi bi-hand-index-thumb"></i> ควบคุมเอง
                        </button>
                        <button type="button" class="pump-mode-btn" :class="{ active: pumpControlMode === 'auto' }" @click="pumpControlMode = 'auto'">
                            <i class="bi bi-cpu"></i> อัตโนมัติ
                        </button>
                    </div>

                    <div class="pump-body" v-if="pumpControlMode === 'manual'">
                        <button
                            type="button"
                            class="pump-toggle-btn"
                            :class="{ 'pump-toggle-on': pumpStatus }"
                            :disabled="pumpLoading"
                            data-bs-toggle="modal"
                            data-bs-target="#pumpConfirmModal"
                            @click="openPumpConfirm()"
                        >
                            <span class="pump-toggle-icon">
                                <i v-if="pumpLoading" class="bi bi-arrow-repeat spin"></i>
                                <i v-else class="bi bi-power"></i>
                            </span>
                            <span class="pump-toggle-text">
                                {{ pumpLoading ? 'กำลังส่งคำสั่ง...' : (pumpStatus ? 'ปิดปั๊มน้ำ' : 'เปิดปั๊มน้ำ') }}
                            </span>
                        </button>
                        <div class="pump-hint">
                            <i class="bi bi-info-circle"></i>
                            แตะเพื่อ{{ pumpStatus ? 'ปิด' : 'เปิด' }}การทำงานของปั๊มน้ำที่สถานีนี้
                        </div>
                    </div>

                    <!-- Automatic / Conditional Control -->
                    <div class="pump-auto-body" v-else>
                        <div class="pump-auto-enable-row">
                            <div class="pump-auto-enable-label">
                                <i class="bi bi-magic"></i>
                                เปิดใช้งานควบคุมอัตโนมัติ
                            </div>
                            <label class="pump-switch">
                                <input type="checkbox" v-model="autoControlEnabled" @change="onAutoControlToggle()">
                                <span class="pump-switch-slider"></span>
                            </label>
                        </div>

                        <div class="pump-auto-rules" :class="{ 'is-disabled': !autoControlEnabled }">
                            <div class="pump-auto-rule">
                                <div class="pump-auto-rule-icon pump-auto-rule-icon-on">
                                    <i class="bi bi-arrow-up-circle-fill"></i>
                                </div>
                                <div class="pump-auto-rule-text">
                                    <span>เปิดปั๊มอัตโนมัติเมื่อระดับน้ำสูงกว่า</span>
                                    <div class="pump-auto-input-wrap">
                                        <input
                                            type="number"
                                            class="pump-auto-input"
                                            v-model.number="autoOnLevel"
                                            :disabled="!autoControlEnabled"
                                        />
                                        <span class="pump-auto-unit">ซม.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="pump-auto-rule">
                                <div class="pump-auto-rule-icon pump-auto-rule-icon-off">
                                    <i class="bi bi-arrow-down-circle-fill"></i>
                                </div>
                                <div class="pump-auto-rule-text">
                                    <span>ปิดปั๊มอัตโนมัติเมื่อระดับน้ำต่ำกว่า</span>
                                    <div class="pump-auto-input-wrap">
                                        <input
                                            type="number"
                                            class="pump-auto-input"
                                            v-model.number="autoOffLevel"
                                            :disabled="!autoControlEnabled"
                                        />
                                        <span class="pump-auto-unit">ซม.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pump-auto-warning" v-if="autoRuleInvalid">
                            <i class="bi bi-exclamation-triangle-fill"></i>
                            ค่าที่ตั้ง "ปิดเมื่อต่ำกว่า" ควรน้อยกว่าค่า "เปิดเมื่อสูงกว่า"
                        </div>

                        <div class="pump-auto-status" v-if="autoControlEnabled">
                            <i class="bi bi-broadcast"></i>
                            <span>ระดับน้ำปัจจุบัน <b>{{ realtimeData.IL }}</b> ซม. —</span>
                            <span v-if="realtimeData.IL > autoOnLevel" class="pump-auto-status-tag pump-auto-status-on">เข้าเงื่อนไขเปิดปั๊ม</span>
                            <span v-else-if="realtimeData.IL < autoOffLevel" class="pump-auto-status-tag pump-auto-status-off">เข้าเงื่อนไขปิดปั๊ม</span>
                            <span v-else class="pump-auto-status-tag pump-auto-status-idle">อยู่ในช่วงปกติ</span>
                        </div>

                        <button
                            type="button"
                            class="pump-auto-save-btn"
                            :disabled="autoSaving || autoRuleInvalid"
                            @click="saveAutoControl()"
                        >
                            <i v-if="autoSaving" class="bi bi-arrow-repeat spin"></i>
                            <i v-else class="bi bi-save2-fill"></i>
                            {{ autoSaving ? 'กำลังบันทึก...' : 'บันทึกเงื่อนไข' }}
                        </button>

                        <div class="pump-auto-saved-msg" v-if="autoSavedMessage">
                            <i class="bi bi-check-circle-fill"></i> {{ autoSavedMessage }}
                        </div>

                        <div class="pump-auto-demo-note">
                            <i class="bi bi-info-circle"></i>
                            ข้อมูลตัวอย่าง (Demo) — ยังไม่เชื่อมต่อ API ควบคุมอัตโนมัติจริง
                        </div>
                    </div>
                </div>

<div class="card chart-card">
                    <div class="chart-header">
                        <div class="chart-title">
                            <i class="bi bi-bar-chart-fill text-cyan"></i>
                            <h3>กราฟข้อมูลระดับน้ำ</h3>
                        </div>
                        <div class="time-selector ">
                            <button v-for="(period, idx) in timePeriods" :key="period" :class="['time-btn', { active: selectedPeriod === idx }]" @click="selectedPeriod = idx,loadChartData('IL||IRAI||ISAL', idx)">
                                {{ period }}
                            </button>
                        </div>
                    </div>
                    <apexchart class=""  type="area" height="250" style="width: 100%;" :options="chartOptions" :series="series"></apexchart>
                     <div class=" text-end">
                      <span style="" type="button" class="btn btn-light py-1" data-bs-toggle="modal" data-bs-target="#chartFullscreenwaterlevelModal">
                        <i class="bi bi-fullscreen"></i>
                        <span style="font-size: 13px;" class="ms-1"> แสดงผลเต็มจอ</span>
                      </span>
                     </div>
                </div>

               
                <div class="card chart-card">
                    <div class="chart-header">
                        <div class="chart-title">
                            <i class="bi bi-battery-charging text-green"></i>
                            <h3>Battery Level</h3>
                        </div>
                        <div class="time-selector">
                            <button v-for="(period, idx) in timePeriods" :key="period" :class="['time-btn', { active: selectedBatteryPeriod === idx }]" @click="selectedBatteryPeriod = idx,loadChartVoltage('B', idx)">
                                {{ period }}
                            </button>
                        </div>
                    </div>
                      <apexchart class="px-2"  type="area" height="250" style="width: 100%;" :options="chartOptions_voltage" :series="series_voltage"></apexchart>
                     <div class=" text-end">
                      <!-- <span style="" type="button" class="btn btn-light py-1" data-bs-toggle="modal" data-bs-target="#chartFullscreenwaterlevelModal">
                        <i class="bi bi-fullscreen"></i>
                        <span style="font-size: 13px;" class="ms-1"> แสดงผลเต็มจอ</span>
                      </span> -->
                     </div>
                </div>
            </div>
            <!-- Right Column -->
            <div class="right-column">
                <!-- Sensor Cards Row 1 -->
                <div class="sensor-grid">
                    <!-- Water Level Card -->
                    <div class="sensor-card water-level-card">
                        <div class="sensor-bg-decoration"></div>
                        <div class="sensor-content">
                            <div class="sensor-update">ล่าสุดเมื่อ {{lastUpdateTime}}</div>
                            <i class="bi bi-water sensor-icon"></i>
                            <!-- IA Status {{ realtimeData.IA }} -->
                            <div class="sensor-value" style="" v-if="realtimeData.IA != 2">{{ realtimeData.IL  }}</div>
                              <div class="sensor-value" style="color: #FB2C36;" v-else>{{ realtimeData.IL  }}</div>
                            <div class="sensor-unit">เซนติเมตร (CM)</div>
                            <div class="sensor-label" style="color: white;">ระดับน้ำ</div>
                        </div>
                    </div>

                    <!-- Temperature Box Card -->
                    <div class="sensor-card temp-box-card">
                        <div class="sensor-bg-decoration"></div>
                        <div class="sensor-content" style="color: #383535FF;">
                            <div class="sensor-update">ล่าสุดเมื่อ {{lastUpdateTime}}</div>
                            <i class="bi bi-thermometer-half sensor-icon"></i>
                            <div class="sensor-value" style="color: #078AD3;">{{ (realtimeData.IT0 / 10).toFixed(2) }}°</div>
                            <div class="sensor-unit">องศา</div>
                            <div class="sensor-label">อุณหภูมิ อากาศ</div>
                        </div>
                    </div>

                    <!-- Water Temperature Card -->
                    <div class="sensor-card water-temp-card">
                        <div class="sensor-bg-decoration"></div>
                        <div class="sensor-content" style="color: #383535FF;">
                            <div class="sensor-update">ล่าสุดเมื่อ {{lastUpdateTime}}</div>
                            <i class="bi bi-droplet-fill sensor-icon"></i>
                            <div class="sensor-value" style="color: #078AD3;">{{ (realtimeData.IT1 / 10).toFixed(2) }}°</div>
                            <div class="sensor-unit">องศา</div>
                            <div class="sensor-label">อุณหภูมิ ในน้ำ</div>
                        </div>
                    </div>

                       <div class="sensor-card-s s-card">
                        <div class="sensor-bg-decoration"></div>
                        <div class="sensor-content" style="color: #383535FF;">
                            <div class="sensor-update">ล่าสุดเมื่อ {{lastUpdateTime}}</div>
                            <i class="bi bi-percent sensor-icon"></i>
                            <div class="sensor-value" style="color: #F86E2F;"><span v-if="realtimeData.ISAL==null">N/A</span><span v-else>{{ (realtimeData.ISAL).toFixed(2) }}</span></div>
                            <div class="sensor-unit">ppt</div>
                            <div class="sensor-label">ความเค็ม</div>
                        </div>
                    </div>
                    <div class="sensor-card rain-card">
                        <div class="sensor-bg-decoration"></div>
                        <div class="sensor-content" style="color: #383535FF;">
                            <div class="sensor-update">ล่าสุดเมื่อ {{lastUpdateTime}}</div>
                            <i class="bi bi-cloud-drizzle sensor-icon"></i>
                            <div class="sensor-value" style="color: #19B394;"><span v-if="realtimeData.IRAI==null">N/A</span><span v-else>{{ realtimeData.IRAI }}</span></div>
                            <div class="sensor-unit">mm</div>
                            <div class="sensor-label">ประมาณน้ำฝน</div>
                        </div>
                    </div>
                 

                    <div class="sensor-card PM-card">
                        <div class="sensor-bg-decoration"></div>
                        <div class="sensor-content" style="color: #383535FF;">
                            <div class="sensor-update">ล่าสุดเมื่อ {{lastUpdateTime}}</div>
                            <i class="bi bi-claude sensor-icon"></i>
                            <div class="sensor-value" style="color: #8666E5;"><span v-if="realtimeData.IT==null">N/A</span><span v-else>N/A</span></div>
                            <div class="sensor-unit">Micrograms per cubic meter</div>
                            <div class="sensor-label">PM 2.5</div>
                        </div>
                    </div>

                    <!-- <div class="card add-sensor-card">
                        <i class="bi bi-plus-lg add-icon"></i>
                        <div class="add-text">Add Other Sensor</div>
                    </div> -->

                </div>

                <!-- Sensor Cards Row 2 -->
                <div class="sensor-grid">
                      <div class="sensor-card  ">
                        <div class="sensor-bg-decoration"></div>
                        <div class="sensor-content" style="color: #383535FF;">
                            <div class="sensor-update">ล่าสุดเมื่อ {{lastUpdateTime}}</div>
                            <i class="bi bi-lightning-charge-fill sensor-icon"></i>
                            <div class="sensor-value" style="color: #E74D4DFF;">  {{ (realtimeData.B / 10).toFixed(2) }}</div>
                            <div class="sensor-unit">โวลท์ (V)</div>
                            <div class="sensor-label">แรงดัน</div>
                        </div>
                    </div>
                    <!-- Status Card -->

                    <div class="card status-card">
                        <div class="sensor-update">ล่าสุดเมื่อ {{lastUpdateTime}}</div>
                        <!-- <div class="status-section">
                            <div class="status-title">สถานะ ระดับน้ำ</div>
                            <div class="status-value status-normal">
                                <span style="color: #278C5B;" v-if="realtimeData.IA==1">ปกติ</span>
                                <span style="color: #FB2C36;" v-else-if="realtimeData.IA==2">วิกฤต</span>
                                <span style="color: #FF8533;" v-else-if="realtimeData.IA==3">เฝ้าระวัง</span>
                            </div>
                        </div> -->
                        <div class="status-section">
                            <div class="status-title">ความแรงสัญญาณ</div>

                            <div class="signal-icon mt-2">

                                <i :class="signalIcon" style="font-size: 65px;"></i>
                                <!-- <div class="text-center" style="font-size: 13px;">RSSI : -{{ realtimeData.Q }} dBm </div> -->
                            </div>
                        </div>
                    </div>

                    <!-- Water Tank Visual -->
                    <div class="card tank-card">
                        <div class="sensor-update">ล่าสุดเมื่อ {{lastUpdateTime}}</div>
                        <div class="tank-header">
                            <i class="bi bi-droplet-half text-cyan"></i>
                            <span>ระดับน้ำ (%)</span>
                        </div>
               <span class="text-center" style="font-size: 13px;font-family: 'Kanit-Regular';">สูงสุด {{ realtimeData.ILH }} CM</span>
                        <div class="tank-visual">
                            <div class="tank-container">
                                <div class="tank-fill" :style="{ height: calculatePercentage() }">
                                    <span class="tank-value">
                                        <div>
                                            <div>
                                                {{ realtimeData.IL }} CM
                                            </div>
                                            <!-- <div class="text-center" style="font-size: 16px;"> {{ calculatePercentage() }} </div> -->
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <span class="text-center" style="font-size: 13px;font-family: 'Kanit-Regular';">ต่ำสุด {{ realtimeData.ILL }} CM</span>
                    </div>

                    <!-- Add Sensor Card -->
                    <!-- <div class="card add-sensor-card">
              <i class="bi bi-plus-lg add-icon"></i>
              <div class="add-text">Add Other Sensor</div>
            </div> -->
                </div>

                <!-- Control Panel -->
                <div class=" col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12" style="    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(20px);
    border-radius: 1.5rem;
    padding: 1.5rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.5);
    transition: all 0.3s ease;">
                    <!-- <div class="control-header">
                        <i class="bi bi-sliders text-cyan"></i>
                        <h3>Update Level Setpoint</h3>
                    </div> -->
                       <div class="sensor-update">ล่าสุดเมื่อ {{lastUpdateTime}}</div>
                    <div class="control-inputs mt-3">
                               <div class="status-section">
                            <div class="status-title">สถานะ ระดับน้ำ</div>
                            <div class="status-value status-normal">
                                <span style="color: #278C5B;" v-if="realtimeData.IA==1">ปกติ</span>
                                <span style="color: #FB2C36;" v-else-if="realtimeData.IA==2">วิกฤต</span>
                                <span style="color: #FF8533;" v-else-if="realtimeData.IA==3">เฝ้าระวัง</span>
                            </div>
                        </div>
                        <div class="input-group mt-3">
                            <label style="min-width: 100px;">     <div class="tank-header">ระดับน้ำสูงกว่า</div></label>
                            <div class="input-wrapper ms-4">
                                <span style="font-size: 18px; font-family: 'Kanit-bold';">{{ realtimeData.ILH }}</span> <span>CM</span> <span style=" margin-left: 100px; background-color: #FB2C36" class="px-3">วิกฤต</span>
                            </div>
                        </div>
                        <div class="input-group">
                            
                            <label style="min-width: 100px;">     <div class="tank-header">ระดับน้ำระหว่าง</div></label>
                            <div class="input-wrapper ms-4">
                                <span style="font-size: 18px; font-family: 'Kanit-bold';">{{ realtimeData.ILL }} - {{ realtimeData.ILH }}</span> <span>CM</span> <span style=" margin-left: 52px;background-color: #FF8533;" class="px-2">เฝ้าระวัง</span>
                            </div>
                        </div>
                        <div class="input-group">
                                 <label style="min-width: 100px;">     <div class="tank-header">ระดับน้ำต่ำกว่า</div></label>
                            <div class="input-wrapper ms-4">
                                <span style="font-size: 18px; font-family: 'Kanit-bold';">{{ realtimeData.ILL }}</span> <span>CM</span> <span style=" margin-left: 98px;background-color: #278C5B;" class="px-3">&nbsp;ปกติ&nbsp; </span>
                            </div>
                        </div>
                        <!-- <div class="control-actions">
                            <button class="btn btn-secondary" @click="undoChanges">Undo</button>
                            <button class="btn btn-primary" @click="saveChanges">Save</button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
</div>
</template>

<script>
import {
    io
} from 'socket.io-client';
import * as bootstrap from 'bootstrap';

import "leaflet/dist/leaflet.css";
import {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,

} from "@vue-leaflet/vue-leaflet";

export default {
       components: {
        LMap,
        LTileLayer,
        LMarker,
        LIcon,

    },
    name: 'WaterDashboard',
    data() {
     const now = new Date().getTime(); // current timestamp in ms
var seriesData =[];


         const seriesData_voltage = [];


        const seriesData2 = Array.from({
            length: 40
        }, (_, i) => {
            return {
                x: new Date(now + i * 3600 * 1000), // add 1 hour per point
                y: Math.floor(Math.random() * 12), // 0,1,2
            };
        });

        return {
            deviceId: null,
             email: localStorage.getItem("email"),
            role: localStorage.getItem("role"),
            loading: false,
            pumpStatus: false,
            pumpLoading: false,
            pumpConfirmPassword: '',
            pumpConfirmError: '',
            pumpConfirmLoading: false,
            showPumpPassword: false,
            pumpControlMode: 'manual',
            autoControlEnabled: false,
            autoOnLevel: 150,
            autoOffLevel: 50,
            autoSaving: false,
            autoSavedMessage: '',
            waterLevel: 69,
            tempBox: 31.2,
            tempWater: 30.2,
            selectedPeriod: 0,
            selectedBatteryPeriod: 0,
            timePeriods: ['1 วัน', '1 สัปดาห์', '1 เดือน', '6 เดือน', '1 ปี'],
            realtimeData: {},
            lastUpdateTime: "",
            locationData: {
                Latitude: 10.7769,
                Longitude: 100.5018,
                name: 'สถานีตรวจวัด BKK-001',
                location: 'ถนนพระราม 4, แขวงคลองเตย, กรุงเทพมหานคร',
                coordinates: '13.7563° N, 100.5018° E',
                promotionCode: '10110',
                province: 'กรุงเทพมหานคร',
                createdAt: '15 ต.ค. 2025'
            },
            controls: {
                levelEffect: 15,
                levelHeight: 300,
                levelLow: 100
            },
              series: [{
                name: "",
                data: seriesData,
            }],
            chartOptions: {
            //   colors:['#078AD3'],
            //  colors: ['#7BBFF0', '#9C9C9CFF','#F86E2F'],
                dataLabels: {
    enabled: false   // 👈 disable data labels
  },
                chart: {
                     datetimeUTC: false,
                     
                    id: "time-x-axis",
                    zoom: {
                        enabled: true
                    },
                      toolbar: {
            export: {
                csv: {
                    filename: "Water-level-data",
                    columnDelimiter: ',',
                    headerCategory: 'time',  // 👈 ตั้งชื่อแกน x เป็น "time"
                },
                svg: {
                    filename: "Water-level-chart",
                },
                png: {
                    filename: "Water-level-chart",
                }
            }
        }
                },
                xaxis: {
                    type: "datetime",
                    title: {
                        text: "เวลา"
                    },
                },
                yaxis: {
                    min: 0,
                    // max: 220,
                    title: {
                        text: "ระดับน้ำ (เซนติเมตร)"
                    },
                },
                title: {
                    // text: "Random Data over Time",
                    align: "center",
                },
                stroke: {
                    // curve: "smooth",
                    // width: 1.4
                },
                markers: {

                    size: 0
                },
            },
                series_voltage: [{
                name: "",
                data: seriesData_voltage,
            }],
            chartOptions_voltage: {
            //   colors:['#078AD3'],
             colors: ['#D63627'],
                dataLabels: {
    enabled: false   // 👈 disable data labels
  },
                chart: {
                    id: "time-x-axis",
                    zoom: {
                        enabled: true
                    },
                      toolbar: {
            export: {
                csv: {
                    filename: "Voltage-data",
                    columnDelimiter: ',',
                    headerCategory: 'time',  // 👈 ตั้งชื่อแกน x เป็น "time"
                },
                svg: {
                    filename: "Voltage-chart",
                },
                png: {
                    filename: "Voltage-chart",
                }
            }
        }
                },
                xaxis: {
                    type: "datetime",
                    title: {
                        text: "เวลา"
                    },
                },
                yaxis: {
                    min: 0,
                    max: 20,
                    title: {
                        text: "แรงดันแบตเตอรี่ (Volt)"
                    },
                },
                title: {
                    // text: "Random Data over Time",
                    align: "center",
                },
                stroke: {
                    // curve: "smooth",
                    width: 1.2
                },
                markers: {

                    size: 0
                },
            },
            series2: [{
                name: "",
                data: seriesData2,
            }],
            chartOptions2: {
                colors: ['#7BBFF0', '#078AD3'],
                dataLabels: {
                    enabled: false // 👈 disable data labels
                },
                chart: {
                    id: "time-x-axis",
                    zoom: {
                        enabled: true
                    },
                },
                xaxis: {
                    type: "datetime",
                    title: {
                        text: "เวลา"
                    },
                },
                yaxis: {
                    // min: 0,
                    // max: 2,
                    title: {
                        text: "แรงดัน (volt)"
                    },
                },
                title: {
                    // text: "Random Data over Time",
                    align: "center",
                },
                stroke: {
                    curve: "smooth",
                    width: 1.2
                },
                markers: {
                    size: 0
                },
            },
        };
    },
    created() {
        this.loadChartData();
        this.loadChartVoltage();
        this.generateChartData();
        // this.checkAndLoad();
         this.getDataLocation();
        // if(this.loading==false){
        // this.getDataLocation();
        // }
        
    },
      computed: {
    signalIcon() {
      const q = this.realtimeData.Q
      if (q > 24 ) return "bi bi-reception-4"
      else if (q > 18 && q<=24) return "bi bi-reception-3"
      else if (q > 13 && q<=18) return "bi bi-reception-2"
      else if (q < 13) return "bi bi-reception-0"
      else return "bi bi-reception-0"
    },
    autoRuleInvalid() {
      return this.autoControlEnabled && Number(this.autoOffLevel) >= Number(this.autoOnLevel);
    }
  },
    beforeUnmount() {
    if (this.socket) {
      this.socket.disconnect();
    }
  },
    methods: {

  async autoRefreshToken() {
  const refreshToken = localStorage.getItem("refreshToken");

  try {
    const response = await fetch(`${process.env.VUE_APP_API_URL}/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken })
    });

    const data = await response.json();

    if (data.accessToken) {
      localStorage.setItem("accessToken", data.accessToken);
      return true;   // บอกว่า refresh สำเร็จ
    } else {
      this.logout();
      return false;
    }
  } catch (error) {
    console.error('Error refreshing token:', error);
    this.logout();
    return false;
  }
},
           logout() {
              localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("email");
        localStorage.removeItem("role");
        // localStorage.clear();
        this.$router.push('/login')
      },
async loadChartVoltage(key = "B", idx = 0) {
 var mode="";
    if(idx == 0){
     mode ="1d"
}else if(idx == 1){
     mode ="1w"
}else if(idx == 2){
     mode ="1m"
}else if(idx == 3){
     mode ="6m"
}else if(idx == 4){
     mode ="1y"
}
  const accessToken = localStorage.getItem("accessToken");
  const url = `${process.env.VUE_APP_API_URL}/api/page/dashboard/${this.$route.query.id}/chart?nameChart=${key}&mode=${mode}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}` // ✅ ใส่ Token ตรงนี้
      },
    });
     if (!response.ok) {
        const refreshed = await this.autoRefreshToken();
        if (refreshed) {
            return this.loadChartVoltage(); // เรียกใหม่
        }
    }

    const result = await response.json();
    if (!result.success) return;

    const seriesApi = result.data.series;
    console.log("Chart Data:", seriesApi);

const TIMEZONE_OFFSET = 7 * 60 * 60 * 1000; // UTC+7 (เวลาไทย)

const chartSeries = seriesApi.map(device => ({
  name: device.device_name,
  data: device.data.map(i => ({
    x: new Date(i.time).getTime() + TIMEZONE_OFFSET,
    y: Number(i[key] ?? 0)
  }))
}));
    

    this.series_voltage = chartSeries;

    this.chartOptions_voltage = {
      ...this.chartOptions_voltage,
      xaxis: {
        type: "datetime",
        title: { text: "เวลา" },
      },
      yaxis: {
        
        // min: 0,
        // max: Math.max(
        //   ...chartSeries.flatMap(s => s.data.map(d => d.y)),
        //   100
        // ),
        
          labels: {
      formatter: function (value) {
        return value.toFixed(1); // แสดง 1 ตำแหน่ง
      },
    },
        title: { text: `แรงดัน (Volt)` },
      },
      tooltip: {
 x: {
  formatter: function (value) {
    const date = new Date(value);
    // ลบ 7 ชั่วโมง (7 * 60 * 60 * 1000 มิลลิวินาที)
    date.setHours(date.getHours() - 7);
    
    return date.toLocaleString("th-TH", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  },
}
}

    };

  } catch (err) {
    console.error("Load Chart Error:", err);
  }
},
async loadChartData(key = "IL||IRAI||ISAL", idx = 0) {
  let mode = ["1d", "1w", "1m", "6m", "1y"][idx] || "1d";

  const accessToken = localStorage.getItem("accessToken");
  const url = `${process.env.VUE_APP_API_URL}/api/page/dashboard/${this.$route.query.id}/chart?nameChart=${key}&mode=${mode}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
      },
    });
     if (!response.ok) {
        const refreshed = await this.autoRefreshToken();
        if (refreshed) {
            return this.loadChartData(); // เรียกใหม่
        }
        throw new Error(`HTTP error! status: ${response.status}`);
        }
    const result = await response.json();
    // if (!result.success) return;
    

    const seriesApi = result.data.series;

    // ✅ เพิ่ม mapping ชื่อภาษาไทย
    const keyLabels = {
      "IL": "ความสูง (CM)",
      "IRAI": "ปริมาณฝน (mm)",
      "ISAL": "ความเค็ม (ppt)"
    };

    // ✅ เตรียม key ที่มีจริงในข้อมูล
    const availableKeys = ["IL", "ISAL", "IRAI"].filter(k =>
      seriesApi.some(device => device.data.some(i => i[k] != null))
    );

    if (availableKeys.length === 0) {
      console.warn("No data available");
      return;
    }

    console.log('Available keys:', availableKeys);

    // ✅ รวมข้อมูลทั้งหมดจาก devices ก่อน
    const mergedData = seriesApi.flatMap(device => device.data);
    mergedData.sort((a, b) => new Date(a.time) - new Date(b.time));

    // ✅ หาค่า min/max ของแต่ละ key
    const keyStats = {};
    availableKeys.forEach(k => {
      const values = mergedData
        .filter(item => item[k] != null)
        .map(item => Number(item[k]));
      
      keyStats[k] = {
        min: values.length > 0 ? Math.min(...values) : 0,
        max: values.length > 0 ? Math.max(...values) : 0,
        count: values.length
      };
    });

    console.log('Key stats:', keyStats);

    // ✅ สร้าง series (ใช้ชื่อภาษาไทยใน legend)
    // const chartSeries = availableKeys.map(k => {
    //   const seriesData = mergedData
    //     .filter(item => item[k] != null)
    //     .map(item => ({
    //       x: new Date(item.time).getTime(),
    //       y: Number(item[k])
    //     }));

    //   return {
    //     name: keyLabels[k], // ✅ ใช้ชื่อภาษาไทย
    //     data: seriesData,
    //   };
    // });
    const chartSeries = availableKeys.map(k => {
  const seriesData = mergedData
    .filter(item => item[k] != null)
    .map(item => ({
      x: new Date(item.time).getTime() + (7 * 60 * 60 * 1000), // +7 ชม (เวลาไทย)
      y: Number(item[k])
    }));

  return {
    name: keyLabels[k],
    data: seriesData,
  };
});

    // ✅ สร้าง multiple yaxis (แต่ละเส้นมีแกนของตัวเอง)
    const yaxisConfig = availableKeys.map((k, index) => {
      const minVal = keyStats[k].min;
      
      return {
        seriesName: keyLabels[k], // ✅ ใช้ชื่อภาษาไทยให้ตรงกับ series.name
        opposite: index % 2 === 1, // สลับซ้าย-ขวา
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: ['#656565FF', '#9C9C9CFF', '#656565FF'][index],
        },
        labels: {
          style: {
            fontSize: '10px',
            padding: 0,
            colors: ['#7B7B7BFF', '#9C9C9CFF', '#656565FF'][index],
          },
          formatter: (val) => {
            if (val == null || isNaN(val)) return '0';
            return val.toFixed(1);
          },
        },
        title: {
  text: keyLabels[k], // ✅ ใช้ชื่อภาษาไทย
//   offsetY: -10, // ✅ ลดระยะห่างแนวตั้ง
//   offsetX: 10, // ✅ ปรับแนวนอนถ้าต้องการ
//   rotate: 0, // ✅ มุมการหัน
  style: {
    color: ['#7B7B7BFF', '#7B7B7BFF', '#656565FF'][index],
    fontSize: '10px',
    fontWeight: 600,
  },
},
        // title: {
        //   text: keyLabels[k], // ✅ ใช้ชื่อภาษาไทย
        //   style: {
        //     color: ['#7B7B7BFF', '#7B7B7BFF', '#656565FF'][index],
        //     fontSize: '10px',
        //     fontWeight: 600,
        //   },
        // },
        min: minVal < 0 ? undefined : 0, // ถ้ามีค่าติดลบให้ auto
        forceNiceScale: true,
      };
    });

    console.log('Yaxis config:', yaxisConfig);

    // ✅ อัพเดท series
    this.series = chartSeries;

    // ✅ รอ Vue update แล้วค่อยอัพเดท options
    this.$nextTick(() => {
  this.chartOptions = {
    chart: {
      id: "multi-y-chart",
      type: "area",
      zoom: { enabled: true },
      animations: {
        enabled: true,
      },
    },
    stroke: { 
      width: [2, 1, 1],
      curve: "smooth" 
    },
    colors: ['#078AD3', '#F86E2F','#19B394'],
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.55, // ✅ ความเข้มด้านบน (0-1)
        opacityTo: 0.0,   // ✅ ความเข้มด้านล่าง (0-1)
        stops: [0, 100],  // ✅ จุดเริ่มต้นและจุดสิ้นสุดของ gradient
        colorStops: []    // ✅ ใช้สีจาก colors โดยอัตโนมัติ
      }
    },
    xaxis: {
      type: "datetime",
      title: { text: "เวลา" },
      labels: {
//   formatter: function (value) {
//           const date = new Date(value);
//           return date.toLocaleString("th-TH", {
//             day: "2-digit",
//             month: "short",
//             // year: "numeric",
//             hour: "2-digit",
//             minute: "2-digit",
//             // second: "2-digit",
//           });
//         },
}   
    },
    yaxis: yaxisConfig,
    tooltip: {
      shared: true,
      intersect: false,
 x: {
  formatter: function (value) {
    const date = new Date(value);
    // ลบ 7 ชั่วโมง (7 * 60 * 60 * 1000 มิลลิวินาที)
    date.setHours(date.getHours() - 7);
    
    return date.toLocaleString("th-TH", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  },
}
    },
    // legend: { 
    //   show: true,
    //   position: 'top',
    //   horizontalAlign: 'center',
    // },
    legend: { 
  show: true,
  position: 'bottom',   // 👈 ย้ายลงล่าง
  horizontalAlign: 'center',
},

  };
});

  } catch (err) {
    console.error("Load Chart Error:", err);
  }
},

//         async loadChartData(key = "IL||IRAI||ISAL", idx = 0) {
//  var mode="";
//     if(idx == 0){
//      mode ="1d"
// }else if(idx == 1){
//      mode ="1w"
// }else if(idx == 2){
//      mode ="1m"
// }else if(idx == 3){
//      mode ="6m"
// }else if(idx == 4){
//      mode ="1y"
// }
//   const accessToken = localStorage.getItem("accessToken");
//   const url = `${process.env.VUE_APP_API_URL}/api/page/dashboard/${this.$route.query.id}/chart?nameChart=${key}&mode=${mode}`;

//   try {
//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         "Authorization": `Bearer ${accessToken}` // ✅ ใส่ Token ตรงนี้
//       },
//     });

//     const result = await response.json();
//     if (!result.success) return;

//     const seriesApi = result.data.series;
//     console.log("Chart Data IL||IRAI||ISAL:", seriesApi);

//     const chartSeries = seriesApi.map(device => ({
//       name: device.device_name,
//       data: device.data.map(i => ({
//         x: new Date(i.time).getTime(),
//         y: Number(i[key] ?? 0)
//       }))
//     }));

//     this.series = chartSeries;

//     this.chartOptions = {
//       ...this.chartOptions,
//       xaxis: {
//         type: "datetime",
//         title: { text: "เวลา" },
//       },
//       yaxis: {
//         min: 0,
//               labels: {
//       formatter: function (value) {
//         return value.toFixed(0); // แสดง 0 ตำแหน่ง
//       },
//     },
//         // max: Math.max(
//         //   ...chartSeries.flatMap(s => s.data.map(d => d.y)),
//         //   100
//         // ),
//         title: { text: `${key} (unit)` },
//       },
//        tooltip: {
//   x: {
//     formatter: function(value) {
//       const date = new Date(value);
//       return date.toLocaleString('th-TH', {
//         day: '2-digit',
//         month: 'short',
//         year: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//         second: '2-digit'
//       });
//     }
//   }
// }
//     };

//   } catch (err) {
//     console.error("Load Chart Error:", err);
//   }
// },
 connectSocket() {
     var accessToken = localStorage.getItem("accessToken");
      if (this.socket) return;
      this.socket = io(`${process.env.VUE_APP_API_URL}/device`, {
        auth: { token: accessToken },
      });

      this.socket.on("connect", () => {
        console.log("✅ Connected to /device");
        this.socket.emit("subscribe", this.deviceId);
      });

      this.socket.on("device:data", (data) => {
        console.log("📡 Data:", data);
         this.realtimeData =data.data;
        // this.messages.push({
        //   device_id: data.device_id,
        //   energy: JSON.stringify(data),
        //   time: data.timestamp ?? "-",
        // });
      });

      this.socket.on("disconnect", () => {
        console.warn("❌ Disconnected");
      });

      this.socket.on("connect_error", (err) => {
        console.error("❌ Connect error:", err.message);
      });
    },
        getMinutesAgoText(timestamp) {
                    // เวลาปัจจุบัน (วินาที)
            const now = Date.now();

            // ปรับเป็นเวลาไทย (UTC+7)
            const thaiNow = now + (7 * 60 * 60 * 1000);

            // แปลงเป็นวินาทีเพื่อเทียบกับ timestamp ที่เป็นวินาที
            const diffInSeconds = Math.floor(thaiNow / 1000) - timestamp;

            if (diffInSeconds < 0) {
                this.lastUpdateTime= "เมื่อสักครู่"; 
            }

            const minutes = Math.floor(diffInSeconds / 60);
            const hours = Math.floor(diffInSeconds / 3600);
            const days = Math.floor(diffInSeconds / 86400);
            const weeks = Math.floor(diffInSeconds / 604800);

            if (minutes < 60) {
                this.lastUpdateTime= `${minutes} นาทีที่แล้ว`;
            } else if (hours < 24) {
                this.lastUpdateTime= `${hours} ชั่วโมงที่แล้ว`;
            } else if (days < 7) {
                this.lastUpdateTime= `${days} วันที่แล้ว`;
            } else {
                this.lastUpdateTime= `${weeks} สัปดาห์ที่แล้ว`;
            }
        },
        calculatePercentage() {
            const percen=100-[((this.realtimeData.ILH-this.realtimeData.IL)-(this.realtimeData.ILH-this.realtimeData.ILL))/(this.realtimeData.ILH-this.realtimeData.ILL)]*100;
            return percen.toFixed(0)+"%";
        },
    async getDataLocation() {
      try {
        var accessToken = localStorage.getItem("accessToken");
      
        
        const response = await fetch(`${process.env.VUE_APP_API_URL}/api/page/dashboard/${this.$route.query.id}/real`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        });

        if (!response.ok) {
        const refreshed = await this.autoRefreshToken();
        if (refreshed) {
            return this.getDataLocation(); // เรียกใหม่
        }
        throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        this.locationData = data.data.plan;
        this.realtimeData =data.data.devices[0].data;
        this.getMinutesAgoText(this.realtimeData.time)
        this.deviceId = data.data.devices[0].device_id;
        if(response.status==200){
          this.loading=true;
           this.connectSocket();
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        this.list_device = [];
      } 
    },  
        generateChartData() {
            this.chartData = Array.from({
                length: 24
            }, (_, i) => ({
                time: `${i}:00`,
                value: 50 + Math.sin(i / 3) * 20 + Math.random() * 10
            }));
        },
        undoChanges() {
            this.controls = {
                levelEffect: 15,
                levelHeight: 300,
                levelLow: 100
            };
        },
        saveChanges() {
            alert('Settings saved!');
        },
        openPumpConfirm() {
            this.pumpConfirmPassword = '';
            this.pumpConfirmError = '';
            this.showPumpPassword = false;
        },
        resetPumpConfirm() {
            this.pumpConfirmPassword = '';
            this.pumpConfirmError = '';
            this.pumpConfirmLoading = false;
            this.showPumpPassword = false;
        },
        async confirmPumpAction() {
            if (!this.pumpConfirmPassword || this.pumpConfirmLoading) return;
            this.pumpConfirmLoading = true;
            this.pumpConfirmError = '';
            try {
                // ยืนยันตัวตนซ้ำด้วยรหัสผ่านผ่าน endpoint เข้าสู่ระบบเดิม ก่อนส่งคำสั่งควบคุมปั๊ม
                const response = await fetch(`${process.env.VUE_APP_API_URL}/auth/signin`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        username: this.email,
                        password: this.pumpConfirmPassword
                    })
                });

                if (!response.ok) {
                    this.pumpConfirmError = 'รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง';
                    return;
                }

                const modalEl = document.getElementById('pumpConfirmModal');
                const modalInstance = bootstrap.Modal.getInstance(modalEl);
                if (modalInstance) modalInstance.hide();

                this.resetPumpConfirm();
                await this.sendPumpCommand();
            } catch (error) {
                console.error('Error verifying password:', error);
                this.pumpConfirmError = 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง';
            } finally {
                this.pumpConfirmLoading = false;
            }
        },
        async sendPumpCommand() {
            if (this.pumpLoading) return;
            const nextStatus = !this.pumpStatus;
            this.pumpLoading = true;
            try {
                const accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/page/dashboard/${this.$route.query.id}/pump`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify({ status: nextStatus ? 1 : 0 })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                this.pumpStatus = nextStatus;
            } catch (error) {
                console.error('Error toggling pump:', error);
                // TODO: ยังไม่มี API ควบคุมปั๊มน้ำจริงฝั่ง backend
                // ตอนนี้จะสลับสถานะที่หน้าจอไว้ก่อน รอเชื่อมต่อ endpoint จริง
                this.pumpStatus = nextStatus;
            } finally {
                this.pumpLoading = false;
            }
        },
        onAutoControlToggle() {
            this.autoSavedMessage = '';
        },
        async saveAutoControl() {
            if (this.autoSaving || this.autoRuleInvalid) return;
            this.autoSaving = true;
            this.autoSavedMessage = '';
            try {
                // TODO: ยังไม่มี API ควบคุมปั๊มแบบอัตโนมัติ (ตามเงื่อนไขระดับน้ำ) จริงฝั่ง backend
                // เมื่อพร้อมแล้วให้เปลี่ยนมายิง POST ไปที่ endpoint จริง เช่น
                // `${process.env.VUE_APP_API_URL}/api/page/dashboard/${this.$route.query.id}/pump/auto`
                // body: { enabled: this.autoControlEnabled, onLevel: this.autoOnLevel, offLevel: this.autoOffLevel }
                // ตอนนี้ใช้ข้อมูลตัวอย่าง (demo) จำลองการบันทึกไปก่อน
                await new Promise(resolve => setTimeout(resolve, 600));
                this.autoSavedMessage = 'บันทึกเงื่อนไข (ข้อมูลตัวอย่าง) เรียบร้อยแล้ว';
            } catch (error) {
                console.error('Error saving auto control rule:', error);
            } finally {
                this.autoSaving = false;
            }
        }
    }
};
</script>
<style scoped>
body {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

html, body {
    overflow-x: hidden;
}

.bg-gradient {
    background-color: #ffffff;
    min-height: 100vh;
    width: 100%;
}

/* Navbar */
.nav-title {
    font-size: 0.875rem;
    font-weight: 500;
}

.breadcrumb {
    font-size: 0.75rem;
    color: #64748b;
}

.breadcrumb-active {
    font-weight: 600;
    color: #0f172a;
}

.user-info-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.user-email {
    font-size: 0.75rem;
    color: #64748b;
}

.user-role {
    font-size: 0.8rem;
    font-family: 'Kanit-Regular';
    color: #0f172a;
}

/* Container */
/* .container-fluid {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    overflow-x: hidden;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
} */

/* Content Grid */
.content-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    width: 100%;
}

.left-column,
.right-column {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    min-width: 0;
}

/* Cards */
.card {
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(20px);
    border-radius: 1.5rem;
    padding: 1.5rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.5);
    transition: all 0.3s ease;
    width: 100%;
    overflow: hidden;
}

.card:hover {
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
}

/* Location Card */
.location-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
    flex-wrap: wrap;
}

.location-header h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
    word-break: break-word;
}

.info-item {
    font-size: 0.8rem;
    color: #64748b;
    margin: 0.5rem 0;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    word-break: break-word;
}

.info-item i {
    color: #94a3b8;
    margin-top: 2px;
    flex-shrink: 0;
}

/* Chart */
.chart-header,
.chart-header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    flex-wrap: wrap;
    gap: 0.75rem;
}

.chart-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-family: 'Kanit-regular';
    flex-wrap: wrap;
}

.chart-title h3 {
    font-size: 0.95rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
}

.time-selector {
    display: flex;
    gap: 0.25rem;
    background: #f1f5f9;
    padding: 0.25rem;
    border-radius: 9999px;
    flex-wrap: wrap;
    min-width: 0;
       justify-content: center;
    align-items: center;
}

.time-btn {
    padding: 0.375rem 0.6rem;
    font-size: 0.7rem;
    font-weight: 500;
    border: none;
    background: transparent;
    color: #64748b;
    border-radius: 9999px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.time-btn:hover {
    color: #0f172a;
}

.time-btn.active {
    background: linear-gradient(135deg, #0ea4e9a7 0%, #0ea4e9e2 100%);
    color: white;
    box-shadow: 0 4px 10px rgba(6, 182, 212, 0.3);
}

.apexchart-responsive {
    width: 100% !important;
    overflow-x: auto;
}

.fullscreen-text {
    font-size: 0.85rem;
}

/* Sensor Grid */
.sensor-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    width: 100%;
}

/* Sensor Cards */
.sensor-card,
.sensor-card-s {
    border-radius: 1.5rem;
    padding: 1.25rem;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    min-width: 0;
}

.sensor-card:hover {
    transform: scale(1.05);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
}

.sensor-bg-decoration {
    position: absolute;
    top: 0;
    right: 0;
    width: 8rem;
    height: 8rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    margin-top: -4rem;
    margin-right: -4rem;
}

.sensor-content {
    position: relative;
    z-index: 1;
}

.water-level-card {
    background: linear-gradient(135deg, #0ea4e9a7 0%, #06b5d4b7 50%, #0ea4e9a7 100%);
    color: white;
}

.temp-box-card,
.water-temp-card,
.rain-card,
.PM-card {
    background: #EFF7FD;
    color: #383535;
}

.s-card {
    background: #f6a37d21;
}

.sensor-update {
    font-size: 0.7rem;
    opacity: 0.8;
    margin-bottom: 0.5rem;
}

.sensor-icon {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    display: block;
}

.sensor-value {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 0.25rem;
    word-break: break-word;
}

.sensor-unit {
    font-size: 0.8rem;
    font-weight: 500;
}

.sensor-label {
    font-family: 'Kanit-bold';
    font-size: 0.95rem;
    opacity: 1;
    margin-top: 0.25rem;
    color: rgb(95, 95, 95);
    word-break: break-word;
}

/* Color Classes */
.danger-text { color: #FB2C36; }
.cyan-text { color: #078AD3; }
.orange-text { color: #F86E2F; }
.green-text { color: #19B394; }
.purple-text { color: #8666E5; }
.red-text { color: #E74D4D; }

/* Status Card */
.status-card {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1.25rem !important;
}

.status-section {
    flex: 1;
}

.status-title {
    font-family: 'Kanit-bold';
    font-weight: 700;
    font-size: 0.8rem;
    color: #475569;
    margin-bottom: 0.5rem;
}

.status-value {
    text-align: center;
    font-size: 1.5rem;
    font-weight: 700;
}

.status-normal {
    color: #278C5B;
}

.status-warning {
    color: #FF8533;
}

.status-danger {
    color: #FB2C36;
}

.signal-icon {
    text-align: center;
}

.signal-icon i {
    font-size: 3.5rem;
    transition: 0.3s;
}

.bi-reception-4 { color: #2ecc71; }
.bi-reception-3 { color: #27ae60; }
.bi-reception-2 { color: #f1c40f; }
.bi-reception-1 { color: #e67e22; }
.bi-reception-0 { color: #e74c3c; }

/* Tank Card */
.tank-card {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1.25rem !important;
}


/* Tank Card */
.tank-header {
 font-family:  'Kanit-bold';
    display: flex;
    align-items: center;
    gap: 0.2rem;
    font-weight: 700;
    font-size: 0.875rem;
    color: #475569;
    margin-bottom: 0.2rem;
}

.tank-visual {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    height: 7rem;
}

.tank-container {
    position: relative;
    width: 5rem;
    height: 100%;
    background: linear-gradient(to bottom, #e2e8f0 0%, #cbd5e1 100%);
    border-radius: 1rem;
    overflow: hidden;
    box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.1);
}

.tank-fill {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: linear-gradient(to top, #06b6d4 0%, #7BBFF0 100%);
    transition: height 0.5s ease;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 0.5rem;
}

.tank-value {
    color: white;
    font-weight: 700;
    font-size: 0.875rem;
}



/* Control Card */
.control-card {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1.25rem !important;
}

.control-inputs {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.input-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.input-group label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #475569;
}

.input-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.input-value {
    font-size: 1.1rem;
    font-family: 'Kanit-bold';
    color: #0f172a;
    font-weight: 700;
}

.input-unit {
    font-size: 0.85rem;
    color: #64748b;
}

.status-badge-normal,
.status-badge-warning,
.status-badge-danger {
    padding: 0.4rem 0.75rem;
    border-radius: 0.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: white;
    white-space: nowrap;
}

.status-badge-normal {
    background-color: #278C5B;
}

.status-badge-warning {
    background-color: #FF8533;
}

.status-badge-danger {
    background-color: #FB2C36;
}

.text-cyan {
    color: #06b6d4;
}

.text-green {
    color: #10b981;
}

/* Marker */
.marker-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.marker-dot,
.marker-dot-warning,
.marker-dot-danger {
    position: relative;
    width: 2.1rem;
    height: 2.1rem;
    border: 2px solid white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.4);
    cursor: pointer;
}

.marker-dot {
    background: linear-gradient(135deg, #278c5b 0%, #3e9e70dd 100%);
}

.marker-dot-warning {
    background: linear-gradient(135deg, #ff8533e1 0%, #ff8533c8 100%);
}

.marker-dot-warning::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #ff8533b5;
    transform: translate(-50%, -50%) scale(1);
    animation: ripple-loop 2s ease-out infinite;
}

.marker-dot-danger {
    background: linear-gradient(135deg, #fb2c36c2 0%, #fb2c36bf 100%);
}

.marker-dot-danger::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #fb2c36d6;
    transform: translate(-50%, -50%) scale(1);
    animation: ripple-loop 2s ease-out infinite;
}

@keyframes ripple-loop {
    0% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0.6;
    }
    70% {
        transform: translate(-50%, -50%) scale(2.5);
        opacity: 0;
    }
    100% {
        opacity: 0;
    }
}

.marker-label,
.marker-label-warning,
.marker-label-danger {
    margin-top: 0.2rem;
    padding: 0.2rem 0.5rem;
    background: white;
    border-radius: 0.5rem;
    font-size: 0.7rem;
    font-weight: 500;
    color: #0f172a;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.marker-label {
    border: 2px solid #278c5b;
}

.marker-label-warning {
    border: 2px solid #fe924fba;
}

.marker-label-danger {
    border: 2px solid #eb5e67b1;
}

/* ============ RESPONSIVE - MOBILE FIRST ============ */

/* Extra Small (< 576px) */
@media (max-width: 575.98px) {
    .container-fluid {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .content-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .card {
        padding: 1rem;
        border-radius: 1rem;
    }

    .chart-header-mobile {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }

    .time-selector {
        width: 100%;
        gap: 0.15rem;
        font-size: 0.65rem;
    }

    .time-btn {
        padding: 0.3rem 0.5rem;
        font-size: 0.65rem;
    }

    .sensor-grid {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }

    .sensor-card,
    .sensor-card-s {
        padding: 1rem;
    }

    .sensor-value {
        font-size: 1.75rem;
    }

    .sensor-label {
        font-size: 0.85rem;
    }

    .sensor-update {
        font-size: 0.65rem;
    }

    .tank-visual {
        height: 5rem;
    }

    .tank-container {
        width: 3.5rem;
    }

    .tank-max-text,
    .tank-min-text {
        font-size: 0.7rem;
    }

    .control-inputs {
        gap: 0.75rem;
    }

    .input-group label {
        font-size: 0.75rem;
    }

    .input-value {
        font-size: 1rem;
    }

    .input-unit {
        font-size: 0.8rem;
    }

    .status-badge-normal,
    .status-badge-warning,
    .status-badge-danger {
        padding: 0.3rem 0.6rem;
        font-size: 0.7rem;
    }

    .location-header h3 {
        font-size: 0.95rem;
    }

    .info-item {
        font-size: 0.75rem;
    }

    .chart-title h3 {
        font-size: 0.9rem;
    }

    .fullscreen-text {
        font-size: 0.8rem;
    }



    .nav-title {
        font-size: 0.75rem;
    }

    .breadcrumb {
        font-size: 0.65rem;
    }
}

/* Small (576px - 767px) */
@media (min-width: 576px) and (max-width: 767.98px) {
    .container-fluid {
        padding-left: 0.75rem;
        padding-right: 0.75rem;
    }

    .content-grid {
        grid-template-columns: 1fr;
        gap: 1.25rem;
    }

    .sensor-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.9rem;
    }

    .card {
        padding: 1.1rem;
    }

    .sensor-value {
        font-size: 1.9rem;
    }

    .time-selector {
        gap: 0.2rem;
    }

    .time-btn {
        padding: 0.35rem 0.55rem;
        font-size: 0.7rem;
    }
}

/* Medium (768px - 991px) */
@media (min-width: 768px) and (max-width: 991.98px) {
    .content-grid {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .sensor-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
    }

    .chart-header-mobile {
        flex-direction: column;
        align-items: flex-start;
    }

    .time-selector {
        width: 100%;
    }
}

/* Large (992px - 1199px) */
@media (min-width: 992px) and (max-width: 1199.98px) {
    .content-grid {
        grid-template-columns: 1fr 1fr;
    }

    .sensor-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

/* Extra Large (≥ 1200px) */
@media (min-width: 1200px) {
    .content-grid {
        grid-template-columns: 1fr 1fr;
        gap: 1.5rem;
    }

    .sensor-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
    }

    .chart-header-mobile {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
}


/* Pump Control Card */
.pump-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
}

.pump-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.pump-title h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
}

.pump-title i {
    color: #06b6d4;
    font-size: 1.1rem;
}

.pump-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.35rem 0.75rem;
    border-radius: 9999px;
    white-space: nowrap;
    font-family: 'Kanit-Regular', sans-serif;
}

.pump-status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.pump-status-badge.pump-on {
    background: rgba(16, 185, 129, 0.12);
    color: #10b981;
}

.pump-status-badge.pump-on .pump-status-dot {
    background: #10b981;
    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.2);
    animation: pump-pulse 1.5s ease-in-out infinite;
}

.pump-status-badge.pump-off {
    background: rgba(100, 116, 139, 0.12);
    color: #64748b;
}

.pump-status-badge.pump-off .pump-status-dot {
    background: #94a3b8;
}

.pump-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
}

.pump-toggle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    width: 100%;
    max-width: 320px;
    padding: 0.9rem 1.5rem;
    border: none;
    border-radius: 9999px;
    font-family: 'Kanit-Regular', sans-serif;
    font-size: 0.95rem;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
    box-shadow: 0 6px 16px rgba(100, 116, 139, 0.35);
    transition: all 0.25s ease;
}

.pump-toggle-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px rgba(100, 116, 139, 0.4);
}

.pump-toggle-btn:active:not(:disabled) {
    transform: translateY(0);
}

.pump-toggle-btn:disabled {
    cursor: not-allowed;
    opacity: 0.85;
}

.pump-toggle-btn.pump-toggle-on {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    box-shadow: 0 6px 18px rgba(16, 185, 129, 0.4);
}

.pump-toggle-btn.pump-toggle-on:hover:not(:disabled) {
    box-shadow: 0 10px 24px rgba(16, 185, 129, 0.45);
}

.pump-toggle-icon {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    line-height: 1;
}

.pump-toggle-icon .spin {
    animation: pump-spin 1s linear infinite;
}

.pump-hint {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.75rem;
    color: #94a3b8;
    text-align: center;
    font-family: 'Kanit-Regular', sans-serif;
}

.pump-icon-spin {
    transition: transform 0.3s ease;
    display: inline-block;
}

.pump-icon-spin.is-spinning {
    animation: pump-spin 2s linear infinite;
}

@keyframes pump-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@keyframes pump-pulse {
    0%, 100% {
        box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.2);
    }
    50% {
        box-shadow: 0 0 0 7px rgba(16, 185, 129, 0.08);
    }
}

/* Pump Confirm Modal */
.pump-confirm-modal-content {
    border-radius: 1.25rem;
    border: none;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
}

.pump-confirm-desc {
    font-size: 0.85rem;
    color: #64748b;
    margin-bottom: 1rem;
    font-family: 'Kanit-Regular', sans-serif;
}

.pump-confirm-input-group {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.7rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.9rem;
    background: #f8fafc;
    transition: all 0.2s ease;
}

.pump-confirm-input-group:focus-within {
    border-color: #06b6d4;
    box-shadow: 0 0 0 3px rgba(6, 182, 212, 0.15);
    background: #fff;
}

.pump-confirm-input-group.is-invalid {
    border-color: #FB2C36;
}

.pump-confirm-input-group i {
    color: #94a3b8;
}

.pump-confirm-input-group .toggle-eye {
    cursor: pointer;
}

.pump-confirm-input-group .toggle-eye:hover {
    color: #64748b;
}

.pump-confirm-input {
    flex: 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 0.9rem;
    font-family: 'Kanit-Regular', sans-serif;
    color: #0f172a;
}

.pump-confirm-error {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.78rem;
    color: #FB2C36;
    margin-top: 0.6rem;
    font-family: 'Kanit-Regular', sans-serif;
}

.pump-cancel-btn {
    background: #f1f5f9;
    color: #64748b;
    border: none;
    border-radius: 9999px;
    padding: 0.55rem 1.25rem;
    font-family: 'Kanit-Regular', sans-serif;
    font-weight: 500;
    font-size: 0.85rem;
}

.pump-cancel-btn:hover {
    background: #e2e8f0;
    color: #334155;
}

.pump-confirm-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    min-width: 140px;
    border: none;
    border-radius: 9999px;
    padding: 0.55rem 1.25rem;
    font-family: 'Kanit-Regular', sans-serif;
    font-weight: 600;
    font-size: 0.85rem;
    color: #fff;
    background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
    transition: all 0.2s ease;
}

.pump-confirm-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.pump-confirm-btn.pump-toggle-on {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.pump-confirm-btn:hover:not(:disabled) {
    filter: brightness(1.05);
}

/* Pump Mode Switch */
.pump-mode-switch {
    display: flex;
    gap: 0.35rem;
    background: #f1f5f9;
    padding: 0.3rem;
    border-radius: 9999px;
    margin-bottom: 1.25rem;
}

.pump-mode-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    padding: 0.5rem 0.75rem;
    border: none;
    background: transparent;
    color: #64748b;
    border-radius: 9999px;
    font-family: 'Kanit-Regular', sans-serif;
    font-size: 0.82rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.pump-mode-btn:hover {
    color: #0f172a;
}

.pump-mode-btn.active {
    background: linear-gradient(135deg, #0ea4e9a7 0%, #0ea4e9e2 100%);
    color: #fff;
    box-shadow: 0 4px 10px rgba(6, 182, 212, 0.3);
}

/* Pump Auto Control */
.pump-auto-body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.pump-auto-enable-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.85rem 1rem;
    background: #f8fafc;
    border-radius: 1rem;
    border: 1px solid #e2e8f0;
}

.pump-auto-enable-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.85rem;
    font-weight: 600;
    color: #0f172a;
    font-family: 'Kanit-Regular', sans-serif;
}

.pump-auto-enable-label i {
    color: #06b6d4;
}

.pump-switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    flex-shrink: 0;
}

.pump-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.pump-switch-slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background-color: #cbd5e1;
    transition: all 0.25s ease;
    border-radius: 9999px;
}

.pump-switch-slider::before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    top: 3px;
    background-color: #fff;
    transition: all 0.25s ease;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.pump-switch input:checked + .pump-switch-slider {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.pump-switch input:checked + .pump-switch-slider::before {
    transform: translateX(20px);
}

.pump-auto-rules {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    transition: opacity 0.2s ease;
}

.pump-auto-rules.is-disabled {
    opacity: 0.5;
    pointer-events: none;
}

.pump-auto-rule {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 1rem;
}

.pump-auto-rule-icon {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    color: #fff;
}

.pump-auto-rule-icon-on {
    background: linear-gradient(135deg, #FB2C36 0%, #e0212b 100%);
}

.pump-auto-rule-icon-off {
    background: linear-gradient(135deg, #278C5B 0%, #1f7248 100%);
}

.pump-auto-rule-text {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    font-size: 0.8rem;
    color: #334155;
    font-family: 'Kanit-Regular', sans-serif;
}

.pump-auto-input-wrap {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.pump-auto-input {
    width: 90px;
    padding: 0.4rem 0.6rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.6rem;
    font-size: 0.9rem;
    font-family: 'Kanit-bold';
    color: #0f172a;
    outline: none;
    transition: all 0.2s ease;
}

.pump-auto-input:focus {
    border-color: #06b6d4;
    box-shadow: 0 0 0 3px rgba(6, 182, 212, 0.15);
}

.pump-auto-unit {
    font-size: 0.8rem;
    color: #64748b;
}

.pump-auto-warning {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.75rem;
    color: #FF8533;
    background: rgba(255, 133, 51, 0.1);
    padding: 0.5rem 0.75rem;
    border-radius: 0.6rem;
    font-family: 'Kanit-Regular', sans-serif;
}

.pump-auto-status {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.4rem;
    font-size: 0.78rem;
    color: #64748b;
    font-family: 'Kanit-Regular', sans-serif;
}

.pump-auto-status i {
    color: #06b6d4;
}

.pump-auto-status-tag {
    padding: 0.2rem 0.6rem;
    border-radius: 9999px;
    font-weight: 600;
    font-size: 0.72rem;
}

.pump-auto-status-on {
    background: rgba(251, 44, 54, 0.12);
    color: #FB2C36;
}

.pump-auto-status-off {
    background: rgba(39, 140, 91, 0.12);
    color: #278C5B;
}

.pump-auto-status-idle {
    background: rgba(100, 116, 139, 0.12);
    color: #64748b;
}

.pump-auto-save-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 9999px;
    font-family: 'Kanit-Regular', sans-serif;
    font-size: 0.88rem;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
    box-shadow: 0 6px 16px rgba(6, 182, 212, 0.3);
    transition: all 0.25s ease;
}

.pump-auto-save-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px rgba(6, 182, 212, 0.35);
}

.pump-auto-save-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.pump-auto-saved-msg {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.78rem;
    color: #10b981;
    font-family: 'Kanit-Regular', sans-serif;
}

.pump-auto-demo-note {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.7rem;
    color: #94a3b8;
    text-align: center;
    justify-content: center;
    font-family: 'Kanit-Regular', sans-serif;
}
</style>